import { valueToCollabJSON } from '@databases/collab/convert/to-collab';
import {
  fieldToDatabase,
  fieldTypeMap,
  valueToDatabase
} from '@databases/collab/convert/to-database';
import { type Database } from '@databases/model/database';
import { type FieldType } from '@databases/model/field';
import { type Value } from '@databases/model/value';
// eslint-disable-next-line workspaces/require-dependency
import { type DefaultRootState } from '@databases/redux/default-root-state';

import { convertType, getInitialValue } from '../../../database/field-types.ts';

export function getConvertedValue(
  db: Database,
  fieldId: string,
  value: Value<FieldType> | undefined,
  type: FieldType,
  state: DefaultRootState | undefined
) {
  const defaultValue = db.defaultEntry.getValue(fieldId);

  let reduxValue;

  if (value) {
    reduxValue = valueToDatabase(value.toJSON());
  } else if (defaultValue) {
    reduxValue = valueToDatabase(defaultValue.toJSON());
  } else {
    reduxValue = getInitialValue(fieldTypeMap[type]);
  }

  const convertedType = convertType(
    {
      field: fieldToDatabase(fieldId, db.fieldsById[fieldId].toJSON()),
      value: reduxValue
    },
    fieldTypeMap[type],
    state
  );

  return valueToCollabJSON(convertedType, {});
}
